// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"17":"51c08528","63":"10b2f2ce","117":"89775e54","409":"52d3bf80","894":"9644da3a"}[chunkId] + ".js";
};